import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/global.css'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import axios from 'axios'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Vue.prototype.$axios = axios

// Vue.config.productionTip = false

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.config.productionTip = false

app.use(ElementPlus,{locale:zhCn}).use(store).use(router).mount('#app')

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}


